import React, { useState, useEffect } from "react";
import { useTheme, } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/commonStyle.css";
import EstimatedFareReadOnly from '../components/booking/components/items/EstimatedFareReadOnly'
import BookingBasicDetails from '../components/booking/components/items/BookingBasicDetails'
import BookingCommunicationDetails from '../components/booking/components/items/BookingCommunicationDetails'
import BookingCabDetails from '../components/booking/components/items/BookingCabDetails'
import BookingCancel from '../components/booking/components/items/BookingCancel'
import AdditionalDetailsCard from "../components/booking/components/fields/AdditionalDetailsCard"
import { ExpandMore, Assignment } from '@mui/icons-material';
import { GetStaticCollection } from '../components/services/staticCollectionService'


const UserBookingDetailsPage: React.FC = () => {
  const location = useLocation();
  const booking = location.state.booking

  const [rideTerms, setRideTerms] = useState<string[]>([]);
  const [cancellationPolicy, setCancellationPolicy] = useState<string[]>([]);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isCancelOpen, setIsCancelOpen] = useState(false);

  const getStaticCollection = async () => {
    try {
      const data = await GetStaticCollection();

      const TermsItem = data?.find((item: any) => item.name === "grp-ride-terms-conditions");
      if (TermsItem) {
        setRideTerms(TermsItem.value);
      }

      const cancelItem = data?.find((item: any) => item.name === "grp-cancellation-policy");
      if (cancelItem) {
        setCancellationPolicy(cancelItem.value);
      }
    } catch (error) {
      console.log("Error fetching static collection", error);
    }
  };

  useEffect(() => {
    getStaticCollection()
  }, [])

  const navigate = useNavigate();
  const theme = useTheme()

  const handleBackBtn = () => {
    navigate("/userNextRidesPage");
  };


  return (
    <div>
      <div className="container my-3" style={{ fontSize: '0.875rem' }}>
        <div className="row justify-content-center px-0">
          <div className="col-12 col-lg-10 col-xl-9 px-0">

            {/* Row: Route and Fare */}
            <div className="row g-4">
              {/* LEFT: Route + Contact Info */}
              <div className="col-12 col-lg-8 d-flex flex-column gap-3">
                {/* Route Card */}
                <BookingBasicDetails booking={booking} />
                <BookingCabDetails booking={booking} />
                <AdditionalDetailsCard booking={booking} />
                <BookingCommunicationDetails booking={booking} />
              </div>

              {/* RIGHT: Payment Card */}
              <div className="col-12 col-lg-4">
                <EstimatedFareReadOnly booking={booking} />
                <BookingCancel booking={booking} />
              </div>

            </div>

            {/* Row: Terms and Cancellation Accordions */}
            <div className="row mt-2">
              <div className="col-12 col-lg-8">
                {/* Terms Accordion */}
                <div className="accordion-item mb-2 shadow-sm rounded border">
                  <h2 className="accordion-header" id="headingTerms">
                    <button
                      className="accordion-button d-flex justify-content-between align-items-center"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTerms"
                      aria-expanded={isTermsOpen}
                      aria-controls="collapseTerms"
                      onClick={() => {
                        setIsTermsOpen(!isTermsOpen);
                        if (!isTermsOpen) setIsCancelOpen(false);
                      }}
                      style={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        padding: '0.5rem 1rem',
                        fontSize: "0.875rem"
                      }}
                    >
                      Terms & Conditions
                <ExpandMore
                        sx={{
                          transition: 'transform 0.3s ease',
                          transform: isTermsOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
                          fontSize: '1.5rem',
                          marginLeft: '0.5rem',
                        }}
                      />
                    </button>
                  </h2>
                  <div
                    id="collapseTerms"
                    className={`accordion-collapse collapse ${isTermsOpen ? 'show' : ''}`}
                    aria-labelledby="headingTerms"
                  >
                    <div className="accordion-body px-4 py-1" style={{ fontSize: '0.8rem' }}>
                      <ul className="mb-0 ps-3 text-start">
                        {rideTerms.map((term, idx) => (
                          <li key={idx} className="mb-2">{term}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Cancellation Accordion */}
                <div className="accordion-item mb-4 shadow-sm rounded border">
                  <h2 className="accordion-header" id="headingCancel">
                    <button
                      className="accordion-button d-flex justify-content-between align-items-center collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseCancel"
                      aria-expanded={isCancelOpen}
                      aria-controls="collapseCancel"
                      onClick={() => {
                        setIsCancelOpen(!isCancelOpen);
                        if (!isCancelOpen) setIsTermsOpen(false);
                      }}
                      style={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        padding: '0.5rem 1rem',
                        fontSize: "0.875rem"
                      }}
                    >
                      Cancellation Policy
                     <ExpandMore
                        sx={{
                          transition: 'transform 0.3s ease',
                          transform: isCancelOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
                          fontSize: '1.5rem',
                          marginLeft: '0.5rem',
                        }}
                      />
                    </button>
                  </h2>
                  <div
                    id="collapseCancel"
                    className={`accordion-collapse collapse ${isCancelOpen ? 'show' : ''}`}
                    aria-labelledby="headingCancel"
                  >
                    <div className="accordion-body px-4 py-1" style={{ fontSize: '0.8rem' }}>
                      <ul className="mb-0 ps-3 text-start">
                        {cancellationPolicy.map((policy, idx) => (
                          <li key={idx} className="mb-2">{policy}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>


                <div>
                  <button
                    type="button"
                    className="btn  w-100 back-button"
                    onClick={handleBackBtn}
                  >
                    Back
                 </button>
                </div>


              </div>
            </div>

          </div>
        </div>
      </div>



    </div>
  );
};

export default UserBookingDetailsPage;
